import React, {useEffect, useState} from 'react'
import SubHeader from '../general/SubHeader';

const Projects = () => {
  const [sites, setSites] = useState([]);

    // Fetch sites data from the backend when the component is mounted
    useEffect(() => {
      const fetchSites = async () => {
        try {
          const response = await fetch('http://localhost:3002/api/get-sites');
          const data = await response.json();
  
          if (response.ok) {
            setSites(data); // Store the fetched sites in state
          } else {
            console.error('Failed to fetch sites:', data);
          }
        } catch (error) {
          console.error('Error while fetching sites:', error);
        }
      };
  
      fetchSites();
    }, []); // Empty dependency array means it runs once when the component mounts

  return (
    <>

      <SubHeader message="Projects" />
      {/* Projects section */}
      <section className='my-5'>
        <div className='container text-center'>

          <p className='sec-subheading'><hr /><span>Projects</span><hr /></p>
          <p className='sec-heading'>Our Listed Properties</p>

          <div className='row mt-4'>

          {sites.length > 0 ? (
              sites.map((site) => (
                <div key={site.id} className='col-lg-4 col-md-6 col-12 my-2 px-4'>
                  <div className='offer-area-outer'>
                    <img src={`http://localhost:3002/uploads/${site.site_image}`} className='img-fluid' style={{height: '16em'}} alt='Exclusive Offers' />
                    <div className='offer-area'>
                      <p className='fw-bold'>{site.site_name}</p>
                      <p className='text-muted'>{site.site_location}</p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>No sites available.</p>
            )}

          </div>
          {/* row ends */}

        </div>
      </section>
      {/* Projects section ends */}
    </>
  )
}

export default Projects
